const okta = {
    tokenExpirationTimeHrs: 1,
    OKTA_TOKEN_STORAGE: 'okta-token-storage',
    Bearer: 'Bearer '
};

export default okta;